import gql from "graphql-tag";

export const ADD_SUPER_INTENDENT_PAVING_CALENDAR = gql`
  mutation addSuperIntendentPavingCalendar($where: SuperIntendentPavingCalendarInput!) {
    addSuperIntendentPavingCalendar(where: $where)
  }
`;